import { BUSINESS_TOOL_SECTIONS } from 'constants/businessTool';

import { ABOUT_COMPANY_INSTRUCTIONS } from './aboutCompany';
import { BUSINESS_OPERATIONS_INSTRUCTIONS } from './businessOperations';
import { ABOUT_COMPANY_INSTRUCTIONS as  ABOUT_COMPANY_INSTRUCTIONS_DEU} from './deu/aboutCompany_deu';
import { BUSINESS_OPERATIONS_INSTRUCTIONS as BUSINESS_OPERATIONS_INSTRUCTIONS_DEU } from './deu/businessOperations_deu';
import { EXECUTIVE_SUMMARY_INSTRUCTIONS as EXECUTIVE_SUMMARY_INSTRUCTIONS_DEU } from './deu/executiveSummary_deu';
import { FINANCIAL_PLAN_INSTRUCTIONS as FINANCIAL_PLAN_INSTRUCTIONS_DEU } from './deu/financialPlan_deu';
import { GLOBAL_INSTRUCTIONS as GLOBAL_INSTRUCTIONS_DEU } from './deu/global_deu';
import { IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS  as IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS_DEU} from './deu/implementationPlan_deu';
import { LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS as LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS_DEU } from './deu/legalFrameworksAndRisks_deu';
import { MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS as MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS_DEU } from './deu/managementAndOrganization_deu';
import { MARKET_ANALYSIS_INSTRUCTIONS as MARKET_ANALYSIS_INSTRUCTIONS_DEU } from './deu/marketAnalysis_deu';
import { MARKETING_AND_SALES_INSTRUCTIONS as MARKETING_AND_SALES_INSTRUCTIONS_DEU } from './deu/marketingAndSales_deu';
import { OVERVIEW_INSTRUCTIONS as OVERVIEW_INSTRUCTIONS_DEU} from './deu/overview_deu';
import { PRODUCTS_AND_SERVICES_INSTRUCTIONS as PRODUCTS_AND_SERVICES_INSTRUCTIONS_DEU } from './deu/productsAndServices_deu';
import { RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS as RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS_DEU } from './deu/raisingAndAllocatingFunds_deu';
import { EXECUTIVE_SUMMARY_INSTRUCTIONS } from './executiveSummary';
import { FINANCIAL_PLAN_INSTRUCTIONS } from './financialPlan';
import { GLOBAL_INSTRUCTIONS } from './global';
import { IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS } from './implementationPlan';
import { LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS } from './legalFrameworksAndRisks';
import { MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS } from './managementAndOrganization';
import { MARKET_ANALYSIS_INSTRUCTIONS } from './marketAnalysis';
import { MARKETING_AND_SALES_INSTRUCTIONS } from './marketingAndSales';
import { OVERVIEW_INSTRUCTIONS } from './overview';
import { PRODUCTS_AND_SERVICES_INSTRUCTIONS } from './productsAndServices';
import { RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS } from './raisingAndAllocatingFunds';
import { ABOUT_COMPANY_INSTRUCTIONS as  ABOUT_COMPANY_INSTRUCTIONS_UA} from './ua/aboutCompany_ua';
import { BUSINESS_OPERATIONS_INSTRUCTIONS as BUSINESS_OPERATIONS_INSTRUCTIONS_UA } from './ua/businessOperations_ua';
import { EXECUTIVE_SUMMARY_INSTRUCTIONS as EXECUTIVE_SUMMARY_INSTRUCTIONS_UA } from './ua/executiveSummary_ua';
import { FINANCIAL_PLAN_INSTRUCTIONS as FINANCIAL_PLAN_INSTRUCTIONS_UA } from './ua/financialPlan_ua';
import { GLOBAL_INSTRUCTIONS as GLOBAL_INSTRUCTIONS_UA } from './ua/global_ua';
import { IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS  as IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS_UA} from './ua/implementationPlan_ua';
import { LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS as LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS_UA } from './ua/legalFrameworksAndRisks_ua';
import { MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS as MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS_UA } from './ua/managementAndOrganization_ua';
import { MARKET_ANALYSIS_INSTRUCTIONS as MARKET_ANALYSIS_INSTRUCTIONS_UA } from './ua/marketAnalysis_ua';
import { MARKETING_AND_SALES_INSTRUCTIONS as MARKETING_AND_SALES_INSTRUCTIONS_UA } from './ua/marketingAndSales_ua';
import { OVERVIEW_INSTRUCTIONS as OVERVIEW_INSTRUCTIONS_UA} from './ua/overview_ua';
import { PRODUCTS_AND_SERVICES_INSTRUCTIONS as PRODUCTS_AND_SERVICES_INSTRUCTIONS_UA } from './ua/productsAndServices_ua';
import { RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS as RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS_UA } from './ua/raisingAndAllocatingFunds_ua';

const getInstructions = (section: string, language: string) => {
  const instructionsMap: Record<string, any> = {
    [BUSINESS_TOOL_SECTIONS.GLOBAL]: {
      en: GLOBAL_INSTRUCTIONS,
      de: GLOBAL_INSTRUCTIONS_DEU,
      uk: GLOBAL_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY]: {
      en: ABOUT_COMPANY_INSTRUCTIONS,
      de: ABOUT_COMPANY_INSTRUCTIONS_DEU,
      uk: ABOUT_COMPANY_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS]: {
      en: BUSINESS_OPERATIONS_INSTRUCTIONS,
      de: BUSINESS_OPERATIONS_INSTRUCTIONS_DEU,
      uk: BUSINESS_OPERATIONS_INSTRUCTIONS_UA,
    },
      [BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY]: {
        en: EXECUTIVE_SUMMARY_INSTRUCTIONS,
        de: EXECUTIVE_SUMMARY_INSTRUCTIONS_DEU,
        uk: EXECUTIVE_SUMMARY_INSTRUCTIONS_UA,
      },
    [BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN]: {
      en: FINANCIAL_PLAN_INSTRUCTIONS,
      de: FINANCIAL_PLAN_INSTRUCTIONS_DEU,
      uk: FINANCIAL_PLAN_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.IMPLEMENTATION_PLAN]: {
      en: IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS,
      de: IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS_DEU,
      uk: IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS]: {
      en: LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS,
      de: LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS_DEU,
      uk: LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: {
      en: MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS,
      de: MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS_DEU,
      uk: MANAGEMENT_AND_ORGANIZATION_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS]: {
      en: MARKET_ANALYSIS_INSTRUCTIONS,
      de: MARKET_ANALYSIS_INSTRUCTIONS_DEU,
      uk: MARKET_ANALYSIS_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.MARKETING_AND_SALES]: {
      en: MARKETING_AND_SALES_INSTRUCTIONS,
      de: MARKETING_AND_SALES_INSTRUCTIONS_DEU,
      uk: MARKETING_AND_SALES_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.OVERVIEW]: {
      en: OVERVIEW_INSTRUCTIONS,
      de: OVERVIEW_INSTRUCTIONS_DEU,
      uk: OVERVIEW_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES]: {
      en: PRODUCTS_AND_SERVICES_INSTRUCTIONS,
      de: PRODUCTS_AND_SERVICES_INSTRUCTIONS_DEU,
      uk: PRODUCTS_AND_SERVICES_INSTRUCTIONS_UA,
    },
    [BUSINESS_TOOL_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: {
      en: RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS,
      de: RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS_DEU,
      uk: RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS_UA,
    },
  };

  return instructionsMap[section]?.[language] || instructionsMap[section]?.en;
};

// Export the instructions object dynamically based on language
export const getBusinessToolFieldsInstructions = (language: string) => ({
  [BUSINESS_TOOL_SECTIONS.GLOBAL]: getInstructions(BUSINESS_TOOL_SECTIONS.GLOBAL, language),
  [BUSINESS_TOOL_SECTIONS.OVERVIEW]: getInstructions(BUSINESS_TOOL_SECTIONS.OVERVIEW, language),
  [BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY]: getInstructions(BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY, language),
  [BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY]: getInstructions(BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY, language),
  [BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES]: getInstructions(BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES, language),
  [BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS]: getInstructions(BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS, language),
  [BUSINESS_TOOL_SECTIONS.MARKETING_AND_SALES]: getInstructions(BUSINESS_TOOL_SECTIONS.MARKETING_AND_SALES, language),
  [BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS]: getInstructions(BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS, language),
  [BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: getInstructions(BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION, language),
  [BUSINESS_TOOL_SECTIONS.IMPLEMENTATION_PLAN]: getInstructions(BUSINESS_TOOL_SECTIONS.IMPLEMENTATION_PLAN, language),
  [BUSINESS_TOOL_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: getInstructions(BUSINESS_TOOL_SECTIONS.RAISING_AND_ALLOCATING_FUNDS, language),
  [BUSINESS_TOOL_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS]: getInstructions(BUSINESS_TOOL_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS, language),
  [BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN]: getInstructions(BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN, language),
});
